import * as React from "react";
import CodeWithCopyButton from "./CodeWithCopyButton";
import "./IntegrationPanel.scss";
import { LinkIcon } from "../commons/components/images/LinkIcon";
import { ScriptIcon } from "../commons/components/images/ScriptIcon";

export interface IntegrationPanelProps {
  pageUrl: string;
  scriptUrl: string;
  title: string;
  pageSubtitleText: string;
  pageContentText: string;
  scriptSubtitleText: string;
  scriptContentText: string;
}

export default function IntegrationPanel(props: IntegrationPanelProps) {
  return (
    <div className="h-flex no-wrap with-margins integration-panel">
      <div className="v-flex with-margins">
        <div className="v-flex">
          <span className="setting-subtitle">{props.pageSubtitleText}</span>
          <span className="setting-note">{props.pageContentText}</span>
        </div>
        <CodeWithCopyButton text={props.pageUrl} icon={LinkIcon()} />
      </div>
      <div className="v-flex with-margins">
        <div className="v-flex">
          <span className="setting-subtitle">{props.scriptSubtitleText}</span>
          <span className="setting-note">{props.scriptContentText}</span>
        </div>
        <CodeWithCopyButton text={atob(props.scriptUrl)} icon={ScriptIcon()} />
      </div>
    </div>
  );
}
